import { hsl } from 'd3';
import { HlsColorInterface } from 'types/store';

export const getHls = (hls: HlsColorInterface) =>
  hsl(Math.floor(hls.h), Math.floor(hls.s) / 100, Math.floor(hls.l) / 100).formatHex();
